import {
  getScrollingProgrammatically,
  registerProgrammaticScrollEnd
} from './scrollToTarget.js';

export function siteHeader() {
  const body = document.body;
  const firstContentBlock = document.querySelector('.section-flow');

  let lastScrollY = window.scrollY;
  let ticking = false;

  /* --------------------------------------------------
     🔑 Resync scroll state after programmatic scrolling
  -------------------------------------------------- */
  registerProgrammaticScrollEnd(() => {
    lastScrollY = window.scrollY;
  });

  /* --------------------------
     Scroll direction handling
  --------------------------- */
  const updateNav = () => {
    if (getScrollingProgrammatically()) return;

    const currentScrollY = window.scrollY;

    if (currentScrollY === 0) {
      // At top: show nav, remove all scroll classes
      body.classList.remove(
        'nav--hidden',
        'nav--scrolling-up',
        'nav--scrolling'
      );
    } else if (currentScrollY > lastScrollY) {
      // Scrolling down → hide nav
      body.classList.add('nav--hidden', 'nav--scrolling');
      body.classList.remove('nav--scrolling-up');
    } else if (currentScrollY < lastScrollY) {
      // Scrolling up → show nav
      body.classList.add('nav--scrolling-up');
      body.classList.remove('nav--hidden', 'nav--scrolling');
    }

    lastScrollY = currentScrollY;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateNav();
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  // Invert nav based on first content block theme
  if (firstContentBlock?.classList.contains('theme--dark')) {
    body.classList.add('nav--invert');
  } else {
    body.classList.remove('nav--invert');
  }

  // Booking CTA visibility based on site visit marker
  if (!firstContentBlock?.querySelector('[data-site-visit]')) {
    body.classList.add('nav--show-booking');
    body.classList.remove('nav--hide-booking');
  } else {
    body.classList.add('nav--hide-booking');
    body.classList.remove('nav--show-booking');
  }

  // Initialise scroll position
  lastScrollY = window.scrollY;
}
